/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AddARTransactionViewModel {
  datasetId?: string;
  visitId?: string;
  patientId?: string;
  paymentCodeId?: string | null;
  adjustmentCodeId?: string | null;
  adjustmentCode2Id?: string | null;
  postingDate?: string;
  transactionDate?: string;
  allowedAmount?: number;
  paymentAmount?: number;
  adjustmentAmount?: number;
  adjustment2Amount?: number;
  deductibleAmount?: number;
  copayAmount?: number;
  coinsuranceAmount?: number;
  checkNumber?: string | null;
  internalControlNumber?: string | null;
  enteredBy?: string | null;
  postedBy?: string | null;
  insuranceId?: string;
  paymentDate?: string | null;
}
